import React, { useState, useEffect} from 'react';
import {Typography, Divider, Box} from '@mui/material';

import Main from '../../../layouts/Main';
import Container from '../../../components/Container';

import eLibraryDocument from '../../../types/legal/eLibraryDocument';
import ChronologicalButtonList from './ChronologicalButtonList';
import PageBreadCrumbs from '../../../components/PageBreadcrumbs';

const AdvisoryOpinionIndex = (): JSX.Element => {

  document.title = 'OCPF - Advisory Opinions';

  const [advisoryOpinions, setAdvisoryOpinions] = useState<eLibraryDocument[]>([]);
  const [years, setYears] = useState<(number)[]>([]);

  useEffect(() => {
    getAdvisoryOpinions();
  },[])


  const getAdvisoryOpinions = async () => {
    try{
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/legal/aos`)
      .then(result => result.json())
      .then(result => {
        setAdvisoryOpinions(result)

        const uniqueYears: number[] = Array.from(
          new Set(
            result
              .map((item: eLibraryDocument) => item.year) 
              .filter((year: number): year is number => year !== undefined)
          )
        );
        setYears(uniqueYears);

      });

    }catch(error){
      console.error('Uncaught Error:', error);
    }
  }

  return (    
    <Main>
      <Container>
        <PageBreadCrumbs></PageBreadCrumbs>
        <Typography
            variant="h5"
            align={'left'}
            data-aos={'fade-up'}
            gutterBottom
            sx={{
              fontWeight: 700,
            }}
            paddingTop={3}>
                 OCPF Advisory Opinions  <Typography component="span" variant="caption" color="text.secondary">by Year Issued</Typography>
        </Typography>
        <Divider/>
        <Box sx={{marginTop: 2, marginBottom: 2}}>
            <Typography variant="h6" align={'left'} paddingTop={1} paddingLeft={2} fontWeight={'bold'}>
            What is an Advisory Opinion?
              </Typography>
              <Typography variant="body1" align={'left'} paddingLeft={2} paddingRight={2}>
              An advisory opinion is a letter written in response to a request for the Director to render an opinion concerning the application of the campaign finance law, or any OCPF regulation, to a specific activity or transaction. Requests for an opinion may be submitted by candidates, committees or the public. See 970 CMR 2.04 for more information.
              </Typography>
        </Box>
        <ChronologicalButtonList years={years} eLibraryDocuments={advisoryOpinions} eLibraryDocumentType={'Advisory Opinions'}/>

      </Container>
    </Main>
  );
};

export default AdvisoryOpinionIndex;